/** Stats routing discriminator for `useStats` query/variable wiring — not GraphQL schema wire values. */
export enum ObjectType {
  USER = 'Client',
  GOAL = 'Goal',
  ACCOUNT = 'Account',
  SUB_ACCOUNT = 'SubAccount',
  CLIENT_GROUP = 'ClientGroup',
  ACCOUNT_GROUP = 'AccountGroup',
}
